import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { setClosedDatesFormSchema } from './set-closed-dates-form.schema';
import { useEffect } from 'react';

export const useSetClosedDatesForm = selectedEvent => {
  const form = useForm({
    resolver: yupResolver(setClosedDatesFormSchema),
    defaultValues: setClosedDatesFormSchema.cast(selectedEvent ?? {}),
  });

  const { reset } = form;
  useEffect(() => {
    reset(selectedEvent ?? {});
  }, [reset, selectedEvent]);

  return { form };
};
